/**
 * Card number input used for adding a card
 *
 * Dependent on getCardSpecs() from https://github.paypal.com/ConsumerWeb-Modules/consumerweb-card/blob/master/lib/card-config.js,
 * but you could just supply an object of specifications similar to what getCardSpecs returns.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { DropdownMenu } from '@paypalcorp/pp-react';

class PhoneType extends React.Component {
  constructor(props) {
    super();
    this.state = {
      selectedIdx: 0,
      phoneTypeErrorMessage: '',
      showIsRequiredError: false,
    };
  }

  handleChange = (index) => {
    this.setState({ selectedIdx: index });
    const phoneTypes = [
      { value: 'Mobile' },
      { value: 'Home' },
      { value: 'Work' },
    ];
    let value = phoneTypes[index].value;
    this.props.changePhoneType(value);
  };

  getPhoneTypeOptions = () => {
    return [
      { primaryText: this.props.guestLabels.phoneTypeMobile },
      { primaryText: this.props.guestLabels.phoneTypeHome },
      { primaryText: this.props.guestLabels.phoneTypeWork },
    ];
  };

  render() {
    const { errorMessage } = this.props;
    let { phoneTypeErrorMessage } = this.state;

    return (
      <div style={{ margin: '0 0 10px' }}>
        <DropdownMenu
          type="button"
          id="phoneTypeSelection"
          selectedItemIndex={this.state.selectedIdx}
          onSelection={this.handleChange}
          label={this.props.guestLabels.phoneType}
          placeholder=""
          options={this.getPhoneTypeOptions()}
          errorText={errorMessage || phoneTypeErrorMessage}
        />
      </div>
    );
  }
}

PhoneType.propTypes = {
  changePhoneType: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  guestLabels: PropTypes.object,
};

export default PhoneType;
